export const AddressNumberIcon = (props) => (
	<svg
		fill="none"
		height={18}
		viewBox="0 0 18 18"
		width={18}
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M13.2428 12.4928L10.0605 15.675C9.92133 15.8143 9.75608 15.9248 9.57417 16.0002C9.39227 16.0756 9.19729 16.1145 9.00038 16.1145C8.80347 16.1145 8.60849 16.0756 8.42658 16.0002C8.24468 15.9248 8.07942 15.8143 7.94025 15.675L4.75725 12.4928C3.91817 11.6536 3.34675 10.5845 3.11527 9.42067C2.88378 8.25679 3.00262 7.05041 3.45676 5.95407C3.91089 4.85773 4.67993 3.92068 5.66661 3.2614C6.6533 2.60213 7.81333 2.25024 9 2.25024C10.1867 2.25024 11.3467 2.60213 12.3334 3.2614C13.3201 3.92068 14.0891 4.85773 14.5433 5.95407C14.9974 7.05041 15.1162 8.25679 14.8847 9.42067C14.6533 10.5845 14.0818 11.6536 13.2428 12.4928Z"
			stroke="#A0A5AF"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M11.25 8.25C11.25 8.84674 11.0129 9.41903 10.591 9.84099C10.169 10.2629 9.59674 10.5 9 10.5C8.40326 10.5 7.83097 10.2629 7.40901 9.84099C6.98705 9.41903 6.75 8.84674 6.75 8.25C6.75 7.65326 6.98705 7.08097 7.40901 6.65901C7.83097 6.23705 8.40326 6 9 6C9.59674 6 10.169 6.23705 10.591 6.65901C11.0129 7.08097 11.25 7.65326 11.25 8.25Z"
			stroke="#A0A5AF"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
